const routes = [
  {
    path: 'traceability-report',
    name: 'traceabilityReport',
    component: () => import(/* webpackChunkName: "traceability-report" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
  },
];

export default routes;
